import { useTranslation } from 'react-i18next';
import { Button } from '@c2fo/liquidity';
import { Circle1LightIcon, Circle2LightIcon } from '@c2fo/liquidity/icons';
import Divider from '@/shared/components/Divider';
import CardForm from './CardForm';

interface OnboardingStepProps {
  stepNumber: React.ReactNode;
  title: string;
  description: string;
  timeEstimate: string;
  ctaLabel: string;
  onCtaClick: () => void;
}

const OnboardingStep = ({
  stepNumber,
  title,
  description,
  timeEstimate,
  ctaLabel,
  onCtaClick,
}: OnboardingStepProps) => {
  return (
    <div className="flex flex-col justify-between gap-6 md:flex-row md:items-center">
      <div className="flex items-center gap-6">
        <div>{stepNumber}</div>
        <div className="space-y-1">
          <div className="font-medium">{title}</div>
          <div>{description}</div>
          <div className="text-sm text-text-secondary">{timeEstimate}</div>
        </div>
      </div>
      <Button variant="primary" onClick={onCtaClick} className="w-fit shrink-0">
        {ctaLabel}
      </Button>
    </div>
  );
};

const InstantPaySection = () => {
  const { t } = useTranslation();

  const handleVerifyDetails = () => {
    // TODO: Launch KYB wizard modal
  };

  const handleConnectAccounts = () => {
    // TODO: Launch Plaid bank connection flow
  };

  return (
    <CardForm.Card
      title={t('core.instantPay')}
      subtitle={t('instantPay.subtitle')}
      content={
        <CardForm.CardContent>
          <OnboardingStep
            stepNumber={<Circle1LightIcon className="size-9 fill-text-secondary" />}
            title={t('instantPay.verifyDetails.title')}
            description={t('instantPay.verifyDetails.description')}
            timeEstimate={t('instantPay.verifyDetails.timeEstimate')}
            ctaLabel={t('instantPay.verifyDetails.cta')}
            onCtaClick={handleVerifyDetails}
          />
          <div className="py-6">
            <Divider />
          </div>
          <OnboardingStep
            stepNumber={<Circle2LightIcon className="size-9 fill-text-secondary" />}
            title={t('instantPay.bankConnection.title')}
            description={t('instantPay.bankConnection.description')}
            timeEstimate={t('instantPay.bankConnection.timeEstimate')}
            ctaLabel={t('instantPay.bankConnection.cta')}
            onCtaClick={handleConnectAccounts}
          />
        </CardForm.CardContent>
      }
    />
  );
};

export default InstantPaySection;
